import { encodeStateAsUpdate } from 'yjs';
import { api } from '@/api';
import type { CollabConfig } from '@/features/collab/types';
import { flushProvider } from '@/features/collab/utils';
import type { SpreadsheetEditor } from '@/features/artifacts/univer';
import { bytesToBase64, gzipBytes } from '@/features/artifacts/utils';
import type { ArtifactOrigin } from '@/features/artifacts/types';

export const collabState = async (
  collab: Pick<CollabConfig, 'provider' | 'ydoc'>,
  { gzip }: { gzip?: boolean } = {},
) => {
  await flushProvider(collab.provider);
  const update = encodeStateAsUpdate(collab.ydoc);
  return bytesToBase64(gzip ? await gzipBytes(update) : update);
};

export const saveArtifactSnapshot = async (
  artifactId: string,
  collab: Pick<CollabConfig, 'provider' | 'ydoc'>,
) =>
  api.post(`v1/artifacts/${artifactId}/collab/snapshot`, {
    expectedState: await collabState(collab),
  });

export const artifactRevisions = (artifactId: string, params: { offset: number; limit: number }) =>
  api.get<
    { revision: number; createdAt: string; createdBy: string | null; origin: ArtifactOrigin }[]
  >(`v1/artifacts/${artifactId}/revisions`, { params });

export const saveSpreadsheetSnapshot = async (artifactId: string, editor: SpreadsheetEditor) => {
  await editor.univerAPI.getCollaboration().flush(artifactId);
  return api.post(`v1/artifacts/${artifactId}/spreadsheet/snapshot`);
};
